import { render, staticRenderFns } from "./ChangelogWidget.vue?vue&type=template&id=0e7d0fbb&scoped=true&"
import script from "./ChangelogWidget.vue?vue&type=script&lang=js&"
export * from "./ChangelogWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogWidget.vue?vue&type=style&index=0&id=0e7d0fbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7d0fbb",
  null
  
)

export default component.exports